import React, { Component } from "react";
import "./style.scss";
import { format } from "date-fns";
import AspectRatioIcon from "@material-ui/icons/AspectRatio";
import IconButton from "@material-ui/core/IconButton";
import bkash from "../../../RouteManagement/svgs/bKash_Logo_Icon_Outlined.svg";
import { Fade, Grow } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import { resolveMediaUrl } from "../../../../utilities/mediaHelper";

const image_config = [
  { key: "outlet_image", title: "Outlet" },
  { key: "posm_image", title: "POSM" },
  { key: "qr_image_link", title: "QR" },
  { key: "shop_remarks_image_1", title: "Remark#1" },
  { key: "shop_remarks_image_2", title: "Remark#2" },
];

export default class FieldForceCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLargeSized: true, //this.props.isLargeSized ? this.props.isLargeSized : false,
      collapseDown: false,
    };
  }
  toggleLargeSize = () => {
    this.setState((prevState) => ({
      isLargeSized: !prevState.isLargeSized,
      collapseDown: false,
    }));
  };

  render() {
    var { info, config } = this.props;

    const formatedDate = format(
      new Date(info.zone_aware_start_time),
      "h:mm a, MMM dd, yyyy"
    );
    info = { ...info, zone_aware_upload_time: formatedDate };
    return (
      <div className="field-force-card">
        <div className="resize-button-container">
          <IconButton
            style={{ opacity: 0.9 }}
            onClick={() =>
              this.setState((prevState) => ({
                collapseDown: !prevState.collapseDown,
              }))
            }
          >
            <InfoIcon />
          </IconButton>
          {/* <IconButton
            aria-label="resize"
            onClick={this.toggleLargeSize}
            style={{
              transform: this.state.isLargeSized
                ? "rotate(360deg)"
                : "rotate(-360deg)",
              transition: "transform 1s ease 0s",
            }}
          >
            <AspectRatioIcon style={{ opacity: 0.9 }} />
          </IconButton> */}
        </div>{" "}
        <div className="image-container">
          {image_config
            .filter((item) => info[item.key])
            .map((item) => (
              <div
                className="single-image"
                style={{ height: this.state.isLargeSized ? "35vh" : "20vh" }}
                key={item.key}
              >
                <img
                  src={resolveMediaUrl(info[item.key])}
                  alt={item.key}
                  style={{
                    height: this.state.isLargeSized ? "35vh" : "20vh",
                    width: this.state.isLargeSized ? "15vw" : "10vw",
                  }}
                />
                {<div className="image-overlay">{item.title}</div>}
              </div>
            ))}
        </div>
        <InfoPopOver data={info} collapseDown={this.state.collapseDown} />
        <div
          className="card-info-container"
          style={{ height: this.state.isLargeSized ? "35vh" : "20vh" }}
        >
          {config &&
            config
              .filter(
                (item) =>
                  (!this.state.isLargeSized && !item.onlyLargeSize) ||
                  this.state.isLargeSized
              )
              .map((item) => (
                <Fade in={true} timeout={2000} key={item.key}>
                  <div className="info">
                    {item.icon && <img src={bkash} alt="bkash" />}
                    <div>
                      <p>{item.title}</p>
                      {info[item.key] ? (
                        <h2 className="primary">{info[item.key]}</h2>
                      ) : (
                        <h2 className="primary not-available">Not available</h2>
                      )}
                      <h2 className="secondary">
                        {item.secondaryKey && info[item.secondaryKey]}
                      </h2>
                    </div>
                  </div>
                </Fade>
              ))}
        </div>
      </div>
    );
  }
}

function humanize(str) {
  var i,
    frags = str.split("_");
  for (i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(" ");
}

const InfoPopOver = ({ data, collapseDown }) => {
  const blackList = [
    "outlet_image",
    "qr_image_link",
    "shop_remarks_image_1",
    "shop_remarks_image_2",
    "posm_image",
  ];
  return (
    <Grow in={collapseDown}>
      <div className="info-popover">
        {Object.keys(data)
          .filter((key) => !blackList.includes(key))
          .map((key) => (
            <div key={key}>
              <p className="title">{humanize(key)}</p>
              <p>{data[key]}</p>
            </div>
          ))}{" "}
      </div>
    </Grow>
  );
};
